import { render, staticRenderFns } from "./EditLoanOfficerAssignment.vue?vue&type=template&id=d406afe4&scoped=true&"
import script from "./EditLoanOfficerAssignment.vue?vue&type=script&lang=js&"
export * from "./EditLoanOfficerAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d406afe4",
  null
  
)

export default component.exports